import React, { useState, useEffect } from 'react';

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data from source.json and pick a random entry
    const fetchData = async () => {
      try {
        const response = await fetch('source.json');
        
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const jsonData = await response.json();
        const things = jsonData.things;
        
        if (!things || things.length === 0) {
          throw new Error('No things found');
        }
        
        // Randomly select one entry from the things array
        const randomIndex = Math.floor(Math.random() * things.length);
        const randomThing = things[randomIndex];
        
        setData(randomThing);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    // Fetch data immediately on mount
    fetchData();

    // Set up interval to refetch every 60 seconds
    const interval = setInterval(fetchData, 60000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
	<div className="main">
		<div className="num">{data.num}</div>
		<div className="thing-i-know">{data.thing}</div>
	</div>
  );
}

export default App;